import '../select/gb-select.tag.html';
import { PageSize } from './gb-page-size';
riot.tag2('gb-page-size', '<yield> <gb-select scope="gb-page-size"> </gb-select> </yield>', '', '', function(opts) {
    this._mixin(PageSize);
});



/** WEBPACK FOOTER **
 ** ./src/tags/page-size/gb-page-size.tag.html
 **/